import { render, staticRenderFns } from "./DokumentUploadModal.vue?vue&type=template&id=f65c261c"
import script from "./DokumentUploadModal.vue?vue&type=script&lang=js"
export * from "./DokumentUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports